import { render, staticRenderFns } from "./AlarmPushesSetting.vue?vue&type=template&id=61379850&scoped=true"
import script from "./AlarmPushesSetting.vue?vue&type=script&lang=js"
export * from "./AlarmPushesSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61379850",
  null
  
)

export default component.exports